import React from 'react';
import SROManagement from '../components/admin/SROManagement';

export default function AdminSROManagement() {
  return (
    <div className="p-4">
      <SROManagement />
    </div>
  );
}